import React from 'react'
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom'
import { DashboardRoutes } from './DashboardRoutes';
import Login from '../Pages/Login';

const RutasPrivadas = ({stateSesion, setStateSesion, component: Component,...rest}) => {
    return (
        <Route
            {...rest}
            render={(props) =>(
                stateSesion
                ?
                    <DashboardRoutes {...props} stateSesion={stateSesion}  setStateSesion={setStateSesion} />
                :
                    <Login {...props} stateSesion={stateSesion}  setStateSesion={setStateSesion} />
            )}
        />
    )
}

RutasPrivadas.propTypes = {
    component : PropTypes.func.isRequired
}

export default RutasPrivadas
